import { CacheOptions } from "@lib-shared/lib/cache";
import { CachedServiceCreator } from "@lib-shared/lib/cached-service";
import getSiteAndCulture from "@menu/core/lib/get-site-and-culture";
import { installerService } from "./instances";
import GeocodeService from "./services/geocode.service";
import { Installer } from "./services/installers/installers.models";

const { culture } = getSiteAndCulture();

const cacheOptions: CacheOptions = {
  timeToLiveInMins: 24 * 60, // 24 hours
  useLocalStorage: true,
  usePrefix: true
}

const geocodingService = new GeocodeService();

const serviceCreator = new CachedServiceCreator(cacheOptions);

const lookupCitiesMethodAsync = async (country: string) => {
  const response = await installerService.getCitiesAsync(country);
  return response.data;
}

const lookupDealersMethodAsync = async (request: any) => {
  const { country, city } = request;
  const response = await installerService.getDealerAsync(country, city);
  return response.data;
}

const lookupInstallersMethodAsync = async (request: any) => {
  const { country, city } = request;
  const response = await installerService.getInstallersAsync(country, city);
  return response.data;
}

const lookupCityCoordinatesMethodAsync = async (request: any) => {
  const { city, country } = request;
  const response = await geocodingService.getCityCoordinatesAsync(city, country);

  //Converting as cache can't store google.maps.LatLng objects
  const coords: google.maps.LatLngLiteral = {
    lat: response.lat(),
    lng: response.lng()
  };

  return coords;
}

const lookupCityCacheKeyGenerator = (request: any) => {
  const { city, country } = request;
  return `${country}.${city}`;
}

export const lookupCitiesService = serviceCreator.create<string[]>(`cities.${culture}`, lookupCitiesMethodAsync);

export const lookupDealersService = serviceCreator.create<Installer[]>(`dealers.${culture}`, lookupDealersMethodAsync);

export const lookupInstallersService = serviceCreator.create<Installer[]>(`installers.${culture}`, lookupInstallersMethodAsync);

export const lookupCityCoordinatesService = serviceCreator.createDynamicKey<google.maps.LatLngLiteral>(lookupCityCacheKeyGenerator, lookupCityCoordinatesMethodAsync);
